<div class="header-container">
  <div class="logo-container">
    <a (click)="toggleSidebar()" href="#" class="sidebar-toggle">
      <nb-icon icon="menu-2-outline"></nb-icon>
    </a>
    <button
      title="Back to this project"
      *ngIf="jobDetailsData"
      nbButton
      ghost
      (click)="navigateToJobsRoute(jobDetailsData.projectName)"
      status="primary"><nb-icon icon="arrow-back-outline"></nb-icon></button>
    <!-- <a class="logo" href="#" (click)="navigateHome()"><img src="/assets/logos/Logo_Statemently.png"></a> &nbsp; -->
  </div>
  <!-- <nb-select [selected]="currentTheme" (selectedChange)="changeTheme($event)" status="primary">
    <nb-option *ngFor="let theme of themes" [value]="theme.value"> {{ theme.name }}</nb-option>
  </nb-select> -->
  <!-- <ngx-layout-direction-switcher class="direction-switcher"></ngx-layout-direction-switcher> -->
</div>

<div class="header-container" *ngIf="jobDetailsData">
  <ngx-single-toolbar [loading]="jobDetailsData.loading" [displayStandardFields]="jobDetailsData.displayStandardFields" [pageIndex]="jobDetailsData.pageIndex"
        [noOfPages]="jobDetailsData.noOfPages" [errorPagesConsolidated]="jobDetailsData.errorPagesConsolidated" [errorPageClick]="jobDetailsData.errorPageClick"
        [statusColor]="jobDetailsData.statusColor" [status]="jobDetailsData.status" [hasChanges]="jobDetailsData.changes.length > 0 ? true : false"
        [fetchAllTables]="jobDetailsData.fetchAllTables"
        [jobId]="jobDetailsData.jobId"
        [startPageNos]="jobDetailsData.startPageNos"
        [statementNo]="jobDetailsData.statementNo"
        [skewFactorX]="jobDetailsData.skewFactorX"
        [skewFactorY]="jobDetailsData.skewFactorY"
        [lineDraw]="jobDetailsData.lineDraw"
        (headerToggle)="headerToggle($event)"
        (changePageEvent)="changePage($event, null)" (commentClick)="onPopverAddCommentClick()"  (reprocessClick)="onReprocessClick()"
        (statusUpdate)="jobVerifiedStatus($event)" (exportClick)="export($event)" (goToNextJob)="proceedToNextJob($event)"
        (layerButton)="layerButton()"
        (horizontalLineButton)="horizontalButton()"
        (verticalLineButton)="verticalButton()"
        (processTableButton)="proceedButton()"
        (discardLinesButton)="undoButton()"
        (revertTableChanges)="undoTableChanges()"
        (infoClick)="infoClick()"
        (deskew)="deskew($event)"
        >
  </ngx-single-toolbar>
</div>

<div class="header-container">
  <nb-actions size="small">

    <!-- <nb-action class="control-item">
      <nb-search type="rotate-layout"></nb-search>
    </nb-action>
    <nb-action class="control-item" icon="email-outline"></nb-action>
    <nb-action class="control-item" icon="bell-outline"></nb-action> -->
    <nb-action class="user-action" *nbIsGranted="['view', 'user']" >
      <nb-user [nbContextMenu]="userMenu"
               [onlyPicture]="userPictureOnly"
               [name]="user?.name"
               [picture]="user?.picture">
      </nb-user>
    </nb-action>
  </nb-actions>
</div>
